module.exports = __webpack_public_path__ + "img/photo-0026.b87049f2.jpg";